import { render } from "./ViewWebhookChannel.vue?vue&type=template&id=65711e52"
import script from "./ViewWebhookChannel.vue?vue&type=script&lang=js"
export * from "./ViewWebhookChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__